<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Menú almacén</h4>
            </div>
            <br>
            <div class="card-body">
                <div class="col-sm-6 float float-left">
                    <br>
                    <div class="areaComentario" style="text-align: center;" routerLink="materialAlmacen">
                        <br>
                        <img style="width: 125px; height: 130px;" src="../../../../assets/images/inventarioAlmacen.png">
                        <br>
                        <h4>Consulta de inventario</h4>
                    </div>
                    <br>
                </div>
                <div class="col-sm-6 float float-right">
                    <br>
                    <div class="areaComentario" style="text-align: center" routerLink="clientesObra">
                        <br>
                        <img style="width: 125px; height: 130px;" src="../../../../assets/images/entradasCliente.png">
                        <br>
                        <h4>Entradas de material por cliente</h4>
                    </div>
                    <br>
                </div>
                <br>
                <div class="col-sm-6 float float-left">
                    <br>
                    <div class="areaComentario" style="text-align: center" routerLink="movimientos">
                        <br>
                        <img style="width: 125px; height: 130px;" src="../../../../assets/images/movimientosAlmacen.png">
                        <br>
                        <h4>Movimientos de almacén</h4>
                    </div>
                    <br>
                </div>
                <div class="col-sm-6 float float-right">
                    <br>
                    <div class="areaComentario" style="text-align: center" routerLink="listarOrdenTrabajo">
                        <br>
                        <img style="width: 125px; height: 130px;" src="../../../../assets/images/ordenesTrabajo.png">
                        <br>
                        <h4>Ordenes de trabajo pendientes por salir</h4>
                    </div>
                    <br>
                </div>
                <br>
                <div class="col-sm-6 float float-left">
                    <br>
                    <div class="areaComentario" style="text-align: center" routerLink="enEspera">
                        <br>
                        <img style="width: 125px; height: 130px;" src="../../../../assets/images/esperados.png">
                        <br>
                        <h4>Material por asignar a almacén</h4>
                    </div>
                    <br>
                </div>
                <div class="col-sm-6 float float-left">
                    <br>
                    <div class="areaComentario" style="text-align: center" routerLink="materialResguardo">
                        <br>
                        <img style="width: 125px; height: 130px;" src="../../../../assets/images/prueba4.png">
                        <br>
                        <h4>Material en resguardo</h4>
                    </div>
                    <br>
                </div>
                <br/>
                <div class="col-sm-6 float float-left">
                    <br>
                    <div class="areaComentario" style="text-align: center" routerLink="listarApoyoTraspaso">
                        <br>
                        <img style="width: 125px; height: 130px;" src="../../../../assets/images/almacenes.png">
                        <br>
                        <h4>Listar apoyos</h4>
                    </div>
                    <br>
                </div>
                <div class="col-sm-6 float float-left">
                    <br>
                    <div class="areaComentario" style="text-align: center" routerLink="listarOrdenApoyo">
                        <br>
                        <img style="width: 125px; height: 130px;" src="../../../../assets/images/almacenes.png">
                        <br>
                        <h4>Ordenes pendientes de apoyo</h4>
                    </div>
                    <br>
                </div>
                <!--
                    <img src="../../../../assets/images/almacenes.jpg" class="img-fluid" alt="Responsive image">
                    <img src="../../../../assets/images/almacenes.jpg" style="opacity: 0.3;" style="position: absolute; right: 0; top: 0; z-index: -100; opacity: 0.3;">
                -->
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/menu/menu.component.html